import './preprocessCompetition';
import { useAsset } from '@artica/assets';
import CompetitionCardFG from './CompetitionCardFG';
import CompetitionPaths from './CompetitionPaths';

export default function Competition() {
  const asset = useAsset('competition');
  return (
    <group name="Competition">
      <CompetitionPaths
        paths={ asset.paths }
      />
      <group name="Competition_Cards_FG">
        { asset.cardFgPaths.map(({ position }, idx) => (
          <CompetitionCardFG
            key={ idx }
            position={ position }
          />
        )) }
      </group>
    </group>
  );
};